import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonList,
  IonPopover,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExitToAppSharpIcon from '@material-ui/icons/ExitToAppSharp';
import React, { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { selectTitle } from 'src/redux/appBar/selectors';
import globalStyles from '../../global-styles/rootGlobalStyles';
import { GenericMessages } from '../../intl/GenericMessages';
import { personCircle, warning } from 'ionicons/icons';
import { AppLimitedMode, useLimitedMode } from 'src/utils/auth/useLimitedMode';
import { DqText } from '../dq-text';
import { uniqueId } from 'lodash';
import { useHasTouchscreen } from '../../utils/helpers/platformHelpers';

interface MobileHeaderProps {
  title?: string;
}

export const MobileHeader: React.FC<MobileHeaderProps> = props => {
  const history = useHistory();
  const hasTouchscreen = useHasTouchscreen();
  const [accountId] = useState(uniqueId('account-popover-'));
  const accountPopover = useRef<HTMLIonPopoverElement>(null);
  const [limitedModeId] = useState(uniqueId('limited-mode-'));
  const limitedModePopover = useRef<HTMLIonPopoverElement>(null);
  const limitedMode = useLimitedMode();

  /**
   * Take page name from store.
   */
  const globalTitle = useSelector(selectTitle);
  const title = props.title ?? globalTitle;

  const signOut = async () => {
    accountPopover.current?.dismiss?.();
    history.push('/logout');
  };

  const goToAccount = () => {
    accountPopover.current?.dismiss?.();
    history.push('/profile');
  };

  return (
    <IonHeader>
      <IonToolbar>
        <IonTitle size="large" style={{ textAlign: 'left', fontSize: globalStyles.TextSizes.TwentyFour }}>
          {!!title ? title : 'Sentinel Link'}
        </IonTitle>
        <IonButtons slot="end">
          {limitedMode.isLimited && (
            <IonButton fill="clear" id={limitedModeId} color="danger">
              <IonIcon slot="icon-only" icon={warning} />
            </IonButton>
          )}
          <IonButton fill="clear" id={accountId} color="medium">
            <IonIcon slot="icon-only" icon={personCircle} />
          </IonButton>
        </IonButtons>
        <IonPopover size="auto" trigger={accountId} ref={accountPopover} triggerAction="click">
          <IonContent fullscreen>
            <IonList style={{ width: '100%', height: '100%' }}>
              <IonItem button onClick={() => goToAccount()} detail={false}>
                <AccountCircleIcon /> &nbsp; <FormattedMessage {...GenericMessages.profile} />
              </IonItem>
              <IonItem button onClick={async () => await signOut()} detail={false}>
                <ExitToAppSharpIcon /> &nbsp; <FormattedMessage {...GenericMessages.signOut} />
              </IonItem>
            </IonList>
          </IonContent>
        </IonPopover>
        {limitedMode.isLimited && (
          <IonPopover
            trigger={limitedModeId}
            ref={limitedModePopover}
            triggerAction={hasTouchscreen ? 'click' : 'hover'}
          >
            <div className="ion-padding">
              <DqText>
                {limitedMode.mode === AppLimitedMode.Offline ? (
                  <FormattedMessage {...GenericMessages.headerBannerLimitedOffline} />
                ) : limitedMode.mode === AppLimitedMode.SessionExpired ? (
                  <FormattedMessage {...GenericMessages.headerBannerLimitedSessionExpired} />
                ) : (
                  <FormattedMessage {...GenericMessages.headerBannerLimitedUnknown} />
                )}
              </DqText>
            </div>
          </IonPopover>
        )}
      </IonToolbar>
    </IonHeader>
  );
};

export default MobileHeader;
